module.exports = __webpack_public_path__ + "static/img/jinghaiqinye.afc54ec0.png";